import {
    useEffect,
    useRef,
    useState,
    forwardRef,
    useImperativeHandle
} from "react";
import refresh from "../assets/images/refresh.svg";

const generateText = (length = 6) => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789abcdefghjklmnpqrstuvwxyz";
    return Array.from({ length }, () =>
        chars.charAt(Math.floor(Math.random() * chars.length))
    ).join("");
};

const CaptchaComponent = forwardRef(({ onVerify, canvasClassName, refreshButtonClassName, textBoxClassName }, ref) => {
    const maxLen = 6;
    const canvasRef = useRef(null);
    const [captcha, setCaptcha] = useState(generateText(maxLen));
    const [input, setInput] = useState("");

    const drawCaptcha = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "#f4f4f4";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        captcha.split("").forEach((char, i) => {
            ctx.save();
            ctx.font = "26px Arial";
            ctx.fillStyle = `rgb(${Math.random() * 150},${Math.random() * 150},${Math.random() * 150})`;
            ctx.translate(20 + i * 22, 32);
            ctx.rotate((Math.random() - 0.5) * 0.5);
            ctx.fillText(char, 0, 0);
            ctx.restore();
        });

        for (let i = 0; i < 5; i++) {
            ctx.beginPath();
            ctx.moveTo(Math.random() * 180, Math.random() * 40);
            ctx.lineTo(Math.random() * 180, Math.random() * 40);
            ctx.strokeStyle = "#252525";
            ctx.stroke();
        }
    };

    useEffect(() => {
        drawCaptcha();
    }, [captcha]);

    const refreshCaptcha = () => {
        setCaptcha(generateText());
        setInput("");
        onVerify(false);
    };

    useImperativeHandle(ref, () => ({
        refreshCaptcha
    }));

    useEffect(() => {
        const valid = input === captcha;
        onVerify(valid);
    }, [input, captcha]);

    return (
        <>
            <canvas ref={canvasRef} width={180} height={40} className={canvasClassName ? canvasClassName  : ""}/>

            <img
                src={refresh}
                alt="Refresh"
                onClick={refreshCaptcha}
                className={refreshButtonClassName ? refreshButtonClassName + " cursor-pointer" : "cursor-pointer"}
            />

            <input
                type="text"
                placeholder="Enter CAPTCHA"
                value={input}
                maxLength={maxLen}
                className={textBoxClassName ? textBoxClassName + " form-control" : "form-control"}
                onChange={(e) => setInput(e.target.value)}
            />
        </>
    );
});

export default CaptchaComponent;
